import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { getStorage, StorageTypes } from '@helpers/storage';
import { isAiSearchOn } from '@helpers/semantic_search';
import { BFLoader } from '@components/common/loader/main';
import { SearchFilterOperator } from '@components/show_page/sections/section_search/SearchTypes';
import AdvancedFiltersDrawer from '../advanced_filters/main';
import LabelsDrawer from '../labels/main';
import DevtoolsDrawer from '../devtools/main';

import './styles/main.scss';

const FiltersDrawer = (props) => {
  const {
    activateLabel,
    activeLabelKey,
    hideLabels,
    labels,
    loading,
    filters,
    filtersDrawerOpen,
    searchableThings,
    searchFilterOperators,
    sections,
    selectedAssetKeys,
    selectedUGTLocale,
    showSectionsFilter,
    toggleFiltersDrawer,
    updateFilters,
    updateSearchFilterOperator,
  } = props;

  const advancedFiltersClass = filtersDrawerOpen === "advanced-filters" ? "open" : "closed";

  const setDrawerState = () => {
    if (getStorage(StorageTypes.Local, 'drawerOpen') === 'advanced-filters' && searchableThings) {
      toggleFiltersDrawer('advanced-filters');
    }
  };

  useEffect(setDrawerState, [searchableThings]);

  return (
    <nav className={classnames('filters-drawer', { open: filtersDrawerOpen !== 'none' })} role="complementary">
      {!hideLabels && labels && labels.labelsTree && labels.labelsTree.children.length > 0 ? (
        <LabelsDrawer
          activateLabel={activateLabel}
          activeLabelKey={activeLabelKey}
          filtersDrawerOpen={filtersDrawerOpen}
          labels={labels}
          selectedAssetKeys={selectedAssetKeys}
          toggleFiltersDrawer={toggleFiltersDrawer}
        />
      ) : null}
      {isAiSearchOn() && (
        <DevtoolsDrawer
          filtersDrawerOpen={filtersDrawerOpen}
          selectedAssetKeys={selectedAssetKeys}
          toggleFiltersDrawer={toggleFiltersDrawer}
        />
      )}
      {!BFG.hasFeature("disable_advanced_filters") && (
        <div className={`advanced-filters-container ${advancedFiltersClass}`}>
          {!searchableThings ? (
            <div className="loader-container">
              <BFLoader />
            </div>
          ) : (
            <AdvancedFiltersDrawer
              filters={filters}
              filtersDrawerOpen={filtersDrawerOpen}
              loading={loading}
              searchFilterOperators={searchFilterOperators}
              searchableThings={searchableThings}
              sections={sections}
              selectedAssetKeys={selectedAssetKeys}
              selectedUGTLocale={selectedUGTLocale}
              showSectionsFilter={showSectionsFilter}
              toggleFiltersDrawer={toggleFiltersDrawer}
              updateFilters={updateFilters}
              updateSearchFilterOperator={updateSearchFilterOperator}
            />
          )}
        </div>
      )}
    </nav>
  );
};

FiltersDrawer.propTypes = {
  activateLabel: PropTypes.func.isRequired,
  activeLabelKey: PropTypes.string,
  hideLabels: PropTypes.bool,
  labels: PropTypes.shape({}),
  loading: PropTypes.bool.isRequired,
  filters: PropTypes.shape({}).isRequired,
  filtersDrawerOpen: PropTypes.oneOf(['labels', 'advanced-filters', 'devtools', 'none']).isRequired,
  searchableThings: PropTypes.shape({}),
  searchFilterOperators: PropTypes.shape({
    custom_fields: PropTypes.shape({ all: PropTypes.oneOf(Object.values(SearchFilterOperator)) }),
    tags: PropTypes.oneOf(Object.values(SearchFilterOperator)).isRequired,
  }).isRequired,
  sections: PropTypes.arrayOf(PropTypes.shape({ section_key: PropTypes.string, name: PropTypes.string })),
  selectedAssetKeys: PropTypes.instanceOf(Set).isRequired,
  selectedUGTLocale: PropTypes.string.isRequired,
  showSectionsFilter: PropTypes.bool,
  toggleFiltersDrawer: PropTypes.func.isRequired,
  updateFilters: PropTypes.func.isRequired,
  updateSearchFilterOperator: PropTypes.func.isRequired,
};

FiltersDrawer.defaultProps = {
  activeLabelKey: null,
  hideLabels: false,
  labels: {},
  searchableThings: null,
  sections: [],
  showSectionsFilter: false,
};

export default FiltersDrawer;
